import CloseIcon from '@mui/icons-material/Close';
import { RefuseConclusionInputModel } from 'inputModels';
import React, { useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import Modal from 'react-modal';
import { useTheme } from 'styled-components';
import { ReactComponent as ExclamationIcon } from '../../../assets/icons/iconExclamation.svg';
import { ReactComponent as ExpandArrowIcon } from '../../../assets/icons/iconExpandArrow.svg';
import { SolicitationController } from '../../../controller/SolicitationController';
import { labelRefusalConclusionReason, RefusalConclusionReason } from '../../../types/enums';
import { Button } from '../../Buttons/Button';
import { SelectControled } from '../../SelectControled';
import { Content, Header } from './styles';

interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
  solicitationId: string;
}

export function ModalSolicitationRefuse({ isOpen, onRequestClose, solicitationId }: Props) {
  const theme = useTheme();
  const [saveLetterText, setSaveLetterText] = useState('');
  const [defaultValues] = useState({
    type: Number(''),
  });

  const MenuProps = {
    PaperProps: {
      style: {
        backgroundColor: theme.colors.background_white,
        color: theme.colors.secondary,
        maxHeight: 250,
      },
    },
  };

  const { control, setValue } = useForm({
    defaultValues,
    reValidateMode: 'onChange',
  });

  const [type] = useWatch({
    control,
    name: ['type'],
  });

  const handleSaveText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setSaveLetterText(e.target.value);
  };

  const handleSendRefusal = () => {
    const refusal: RefuseConclusionInputModel = {
      solicitationId,
      refusalConclusionReason: type,
      refusalConclusionJustificative: saveLetterText,
    };

    SolicitationController.refuseConclusion(refusal).then(() => {});
    onRequestClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-edit-modal-content">
      <Header>
        <div className="content-header">
          <ExclamationIcon />
          <h1>Recusar conclusão da solicitação</h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={onRequestClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>

      <Content>
        <SelectControled
          name="type"
          control={control}
          MenuProps={MenuProps}
          IconComponent={ExpandArrowIcon}
          defaultValue=""
          onChange={(e) => {
            setValue('type', e.target.value as number);
          }}
          placeholderTitle="Selecione"
          itens={Object.keys(RefusalConclusionReason)
            .filter((refusalType) => !isNaN(Number(refusalType)))
            .map((refusalType) => ({
              id: refusalType,
              value:
                labelRefusalConclusionReason[refusalType as unknown as RefusalConclusionReason],
            }))}
        />
        <p>Escreva mais detalhes da recusa para o demandante.</p>
        <textarea name="details" id="details" cols={30} rows={6} onChange={handleSaveText} />

        <div className="buttons">
          <Button
            text="Descartar"
            dimensions={{ width: '12rem', height: '2rem' }}
            color="background_white"
            backgroundHoverColor="tertiary_500"
            border={{ color: 'transparent', width: 1 }}
            textHoverColor="background_white"
            onClick={() => onRequestClose()}
          />
          <Button
            text="Enviar recusa"
            dimensions={{ width: '12rem', height: '2rem' }}
            color="background_white"
            backgroundHoverColor="primary"
            background="secondary"
            textHoverColor="background_white"
            border={{ color: 'transparent', width: 1 }}
            onClick={handleSendRefusal}
          />
        </div>
      </Content>
    </Modal>
  );
}
